import React, {useEffect, useState} from "react";
import general from "../../../general";
import {Link} from "react-router-dom";
import $ from "jquery";
import {useUpdateEffect, useScroll} from "ahooks";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import useActiveState from "../../../lib/useActiveState";
import Subtitle from "../../components/Subtitle";
import GameTags from "../../components/game/GameTags";
import GameInfo from "../../components/Home/GameInfo";
import FreeEdition from "../../components/FreeEdition";

export default props => {
  const [agent] = useActiveState('agent');
  const [init, setInit] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [games, setGames] = useState([]);
  const [more, setMore] = useState(true);
  const [randomColorInfo] = useActiveState('randomColorInfo');//随机颜色
  const load = (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    let tmp = {
      type: 2,
      game_species_type: props.type,
      pagination: {page: page},
    };
    if (parms.page) {
      tmp.pagination = {page: parms.page};
    }
    general.axios.post('/recentlyPlayGame', tmp)
        .finally(() => {
          setLoading(false);
          Dialog.close();
        })
        .then(response => {
          setInit(true);
          let result = response.data.data;
          if (parms.page) {
            setPage(parms.page);
          }
          result.game_list.forEach(d => {
            d.infoColor = randomColorInfo[parseInt(Math.random() * 4)]
          })
          setGames(games => parms.page === 1 || !parms.page ? result.game_list : [...games, ...result.game_list]);
          setMore(result.paginated.more);
        })
        .catch(err => {
          Dialog.error(err.message);
        });
  }
  useEffect(() => {
    if (props.active && !init) {
      load();
    }
  }, [props.active]);
  // useUpdateEffect(() => {
  //   if (props.active && (!init || props.action === 'POP')) {
  //     load();
  //   }
  // }, [props]);

  const scroll = useScroll();
  useEffect(() => {
    if (props.active && init) {
      if (scroll.top < -80) {
        load({page: 1});
      }
      if (scroll.top + window.innerHeight + 20  > $(document).height() && more) {
        load({page: page + 1});
      }
    }
  }, [scroll, props.active]);

  return <div className="play-game">
    {games.map(game => <Link to={'/game?id=' + game.game_id + '&tt=1&agent='+agent} className="item">
      <div className="icon">
        <Image src={game.game_image.thumb}/>
      </div>
      <div className="subject">
        <div className="text">
          <div className="name">
            {/* {game.top_lable != '' ? <span>{game.top_lable }</span> : null }{game.game_name} */}
            <div className={" " + (game.nameRemark ? " name-new" : "")}>
              {game.top_lable != '' ? <span className="span">{game.top_lable }</span> : null }
              {game.game_name}
            </div>
          </div>
          <GameInfo>{game}</GameInfo>
          <GameTags game={game}></GameTags>
        </div>
        {/* <div className="btn">{game.game_species_type != 3 ? '下载' : '开始'}</div> */}
      </div>
      <FreeEdition>{game}</FreeEdition>
    </Link>)}
    {games.length > 6 && !more ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
    {games.length === 0 && init ? <div className="recovery-empty"><img src="/resources/user/game_empty.png" alt=""/>暂未玩过任何游戏</div> : null}
  </div>;
};